const dev = {
    firebase: {
        apiKey: "AIzaSyCAwp4VuMRPh1p9-UbdqbX0yQEKyxl7hM8",
        authDomain: "dev-appli-app.firebaseapp.com",
        projectId: "dev-appli-app",
        storageBucket: "dev-appli-app.firebasestorage.app",
        messagingSenderId: "743855311009",
        appId: "1:743855311009:web:80f6397ad3f7e1f32108e0",
    },
    candidateApiUrl: "https://dev-candidates-portal-api.applisolutions.com",
    coreApiUrl: "https://dev-core-api.applisolutions.com",
    marketplaceUrl: "http://localhost:3001",
    // The Firebase Hosting site is the address; dev-certs.applisolutions.com is a custom
    // domain the owner has not linked yet, and until he does it does not resolve at all.
    // Kept as a "dev-" host on purpose: certificate-site/config.js reads the environment
    // off its own hostname and routes any host containing "dev-" to the dev API.
    certificateSiteUrl: "https://dev-appli-certificates.web.app",
    // The one origin allowed to frame this app as an admin view, and the only one the
    // frame will hand a token to. See src/config/adminViewSession.js. Empty disables the
    // seam entirely, which is the correct default for any build with no admin portal.
    adminPortalOrigin: "https://dev-admin.applisolutions.com",
};

export default dev;
